<template>
  <div class="gc-number-plus-minus-container">
    <DxNumberBox :value.sync="numericValue">
      <DxNumberBoxButton
        name="minus"
        location="before"
        :options="minusButton"
      />
      <DxNumberBoxButton name="plus" location="after" :options="plusButton" />
    </DxNumberBox>
  </div>
</template>

<script>
import {
  DxNumberBox,
  DxButton as DxNumberBoxButton,
} from "devextreme-vue/number-box";
export default {
  components: {
    DxNumberBox,
    DxNumberBoxButton,
  },
  props: {
    numValue: {
      type: Number,
      default: 0,
    },
    min: {
      default: 0,
      type: Number,
    },
    max: {
      default: 10,
      type: Number,
    },
  },
  data() {
    return {
      numericValue: this.numValue,
      timer: null,
      minusButton: {
        icon: "minus",
        stylingMode: "contained",
        onClick: () => {
          this.decreaseNumber();
        },
      },
      plusButton: {
        icon: "plus",
        stylingMode: "contained",
        onClick: () => {
          this.increaseNumber();
        },
      },
    };
  },
  methods: {
    decreaseNumber() {
      this.numericValue -= 1;
    },
    increaseNumber() {
      this.numericValue += 1;
    },
    inputValue(evt) {
      this.numericValue = evt.target.value ? parseInt(evt.target.value) : 0;
    },
  },
  watch: {
    numericValue: function(val, oldVal) {
      if (val <= this.min) {
        this.numericValue = parseInt(this.min);
      }
      if (val >= this.max) {
        this.numericValue = parseInt(this.max);
      }
      if (val <= this.max && val >= this.min) {
        // eslint-disable-next-line no-console
        // this.$logger.debug(`old:${oldVal} new: ${val}`);
        this.$emit("input", val, oldVal);
        this.$emit("update", val);
      }
    },
  },
};
</script>

<style lang="scss">
.gc-number-plus-minus-container {
  background: #fff;
}
</style>
